//数据看板
export default {
	//新品上市/上架统计-上市新品数据
	newProductOnSale: {
		url: '/ec-goods-new-api/newProductAnalyze/newProductOnSale',
		type: 'post'
	},
	//新品上市/上架统计-上市清单数据
	saleListData: {
		url: '/ec-goods-new-api/newProductAnalyze/saleListData',
		type: 'post'
	},
	//新品上市/上架统计-新品销量数据
	newProductSaleData: {
		url: '/ec-goods-new-api/newProductAnalyze/newProductSaleData',
		type: 'post'
	},
	//新品上市/上架统计-店铺上架数据
	storeData: {
		url: '/ec-goods-new-api/newProductAnalyze/storeData',
		type: 'post'
	},
	//新品上市/上架统计-店铺上架数据(柱状图)
	storeItemData: {
		url: '/ec-goods-new-api/newProductAnalyze/storeItemData',
		type: 'post'
	},
	//在售品变更统计 - 变更商品数合计
	updateProductTotal: {
		url: '/ec-goods-new-api/onSaleAnalyze/updateProductTotal',
		type: 'post'
	},
	//在售品变更统计 - 变更商品月度统计折线图
	getOnSaleAnalyzeItem: {
		url: '/ec-goods-new-api/onSaleAnalyze/getOnSaleAnalyzeItem',
		type: 'post'
	},
	//在售品变更统计 - 店铺处理数据
	getOnSaleAnalyzeStore: {
		url: '/ec-goods-new-api/onSaleAnalyze/getOnSaleAnalyzeStore',
		type: 'post'
	},
	//在售品变更统计 - 店铺处理柱状图
	getOnSaleAnalyzeStoreItem: {
		url: '/ec-goods-new-api/onSaleAnalyze/getOnSaleAnalyzeStoreItem',
		type: 'post'
	},
	//代办任务台 - 上市清单统计
	newProductListStatistics: {
		url: '/ec-goods-new-api/workbench/newProductListStatistics',
		type: 'get'
	},
	//代办任务台 - 上市清单平均耗时天数统计
	getListDelayDays: {
		url: '/ec-goods-new-api/workbench/getListDelayDays',
		type: 'get'
	},
	//代办任务台 - 新品上架统计
	newProductUpStatistics: {
		url: '/ec-goods-new-api/workbench/newProductUpStatistics',
		type: 'get'
	},
	//代办任务台 - 新品上架店铺平均耗时排名统计
	rankStore: {
		url: '/ec-goods-new-api/workbench/rankStore',
		type: 'post'
	},
	//代办任务台 - 新品上架店铺待上架商品排名统计
	rankGoods: {
		url: '/ec-goods-new-api/workbench/rankGoods',
		type: 'post'
	},
	//代办任务台 - 在售变更信息店铺获取
	queryOnSaleStore: {
		url: '/ec-goods-new-api/workbench/queryOnSaleStore',
		type: 'get'
	},
	//代办任务台 - 在售变更信息数据获取
	getWbOnSaleData: {
		url: '/ec-goods-new-api/workbench/getWbOnSaleData',
		type: 'get'
	},
	//代办任务台 - 在售变更信息已处理平均耗时排名
	getOnSaleStoreRank: {
		url: '/ec-goods-new-api/workbench/getOnSaleStoreRank',
		type: 'post'
	},
	//代办任务台 - 在售变更信息待处理商品总数排名
	getOnSaleGoodsRank: {
		url: '/ec-goods-new-api/workbench/getOnSaleGoodsRank',
		type: 'post'
	},
	//代办任务台 - 在售变更信息待处理商品详情
	getWbOnSaleDataItem: {
		url: '/ec-goods-new-api/workbench/getWbOnSaleDataItem',
		type: 'post'
	},
	//代办任务台 - 拍摄、修片、渲染统计
	getSpuStatics: {
		url: '/ec-goods-new-api/workbench/getSpuStatics',
		type: 'post'
	},
	//代办任务台 - 拍摄、修片、渲染平均耗时统计
	querySpuStaticsDay: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsDay',
		type: 'post'
	},
	//代办任务台 - 拍摄、修片、渲染待完成总数排名
	querySpuStaticsFinish: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsFinish',
		type: 'post'
	},
	//代办任务台 - 拍摄、修片、渲染待完成总数详情
	querySpuStaticsFinishDetail: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsFinishDetail',
		type: 'post'
	},
	//代办任务台 - 切片统计
	querySpuStaticsSlice: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsSlice',
		type: 'post'
	},
	//代办任务台 - 切片平均耗时排名
	querySpuStaticsSliceDay: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsSliceDay',
		type: 'post'
	},
	//代办任务台 - 切片待完成总数排名
	querySpuStaticsSliceFinish: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsSliceFinish',
		type: 'post'
	},
	//代办任务台 - 切片完成总数详情
	querySpuStaticsSliceFinishDetail: {
		url: '/ec-goods-new-api/workbench/querySpuStaticsSliceFinishDetail',
		type: 'post'
	},

}